const API_PREFIX_V1 = '/commerce/api';
const API_PREFIX_V2 = '/commerce/api/v2';

/** socket.io path (direct gateway 또는 /commerce/api 프록시 공통) */
export const SOCKET_IO_PATH = `${API_PREFIX_V1}/ws/events/socket.io`;

export const ENDPOINTS = {
  user: () => `/api/v1/users`,
  onboarding: () => `${API_PREFIX_V1}/users/me/status`,
  common: {
    meta: () => `${API_PREFIX_V1}/common/metadata`,
    presignedUrls: () => `${API_PREFIX_V1}/common/presigned-urls`,
  },
  product: {
    base: () => `${API_PREFIX_V1}/products`,
    item: (productId: string) => `${API_PREFIX_V1}/products/${productId}`,
    // 에셋 추가
    attachments: (productId: string) =>
      `${API_PREFIX_V1}/products/${productId}/attachments`,
    // 에셋 삭제
    deleteAttachments: (productId: string) =>
      `${API_PREFIX_V1}/products/${productId}/attachments/soft`,
    // 이미지 태깅 정보 수정
    imageInfo: (productId: string, attachmentId: string) =>
      `${API_PREFIX_V1}/products/${productId}/attachments/${attachmentId}/image-info`,
    // 썸네일 업데이트
    mainImage: (productId: string) =>
      `${API_PREFIX_V1}/products/${productId}/thumbnail`,
  },
  detail: {
    item: (detailId: string) => `${API_PREFIX_V1}/details/${detailId}`,
    module: (detailId: string, moduleId: string) =>
      `${API_PREFIX_V1}/details/${detailId}/modules/${moduleId}`,
    // ai chat 생성
    aiChatByFile: (detailId: string) =>
      `${API_PREFIX_V1}/details/${detailId}/ai-chat-file`,
    aiChat: (detailId: string) =>
      `${API_PREFIX_V1}/details/${detailId}/ai-chat`,
  },
  credit: {
    info: () => `${API_PREFIX_V1}/credits`,
  },
  banner: {
    base: () => `${API_PREFIX_V1}/banners`,
    item: (bannerId: string) => `${API_PREFIX_V1}/banners/${bannerId}`,
    variations: (bannerId: string) =>
      `${API_PREFIX_V1}/banners/${bannerId}/variations`,
    variation: (bannerId: string, variationId: string) =>
      `${API_PREFIX_V1}/banners/${bannerId}/variations/${variationId}`,
    variationThumbnail: (bannerId: string, variationId: string) =>
      `${API_PREFIX_V1}/banners/${bannerId}/variations/${variationId}/thumbnail`,
    resize: (bannerId: string) => `${API_PREFIX_V1}/banners/${bannerId}/resize`,
    size: (bannerId: string, aspectRatio: string) =>
      `${API_PREFIX_V1}/banners/${bannerId}/sizes/${aspectRatio}`,
    aiChat: (bannerId: string, variationId: string) =>
      `${API_PREFIX_V1}/banners/${bannerId}/variations/${variationId}/ai-chat`,
  },
  aiStudio: {
    images: () => `${API_PREFIX_V1}/ai-studio/images`,
    inpainting: () => `${API_PREFIX_V1}/ai-studio/inpainting`,
    galleries: () => `${API_PREFIX_V1}/ai-studio/galleries`,
    galleryImage: (galleryId: string, imageId: string) =>
      `${API_PREFIX_V1}/ai-studio/galleries/${galleryId}/images/${imageId}`,
    assets: () => `${API_PREFIX_V1}/ai-studio/assets`,
    presets: () => `${API_PREFIX_V1}/ai-studio/presets`,
  },
  video: {
    base: () => `${API_PREFIX_V1}/videos`,
    item: (videoId: string) => `${API_PREFIX_V1}/videos/${videoId}`,
  },
  landing: {
    chatbot: () => `${API_PREFIX_V1}/landing/chatbot/messages`,
    vton: {
      run: () => `${API_PREFIX_V1}/landing/vton/run`,
      results: (jobId: string) =>
        `${API_PREFIX_V1}/landing/vton/results/${encodeURIComponent(jobId)}`,
    },
  },
} as const;

export const ENDPOINTS_V2 = {
  product: {
    base: () => `${API_PREFIX_V2}/products`,
    attachments: (productId: string) =>
      `${API_PREFIX_V2}/products/${productId}/attachments`,
  },
  detail: {
    base: () => `${API_PREFIX_V2}/details`,
    item: (detailId: string) => `${API_PREFIX_V2}/details/${detailId}`,
    module: (detailId: string, moduleId: string) =>
      `${API_PREFIX_V2}/details/${detailId}/modules/${moduleId}`,
    component: (detailId: string, moduleId: string, componentId: string) =>
      `${API_PREFIX_V2}/details/${detailId}/modules/${moduleId}/components/${componentId}`,
  },
} as const;
